import styled, { css } from 'styled-components/macro';
import { Col } from '@yme/atoms/grid';
import { colorAccentLinkLight, colorCoreBlack300, colorCoreBlack900Base, colorCoreGray100, colorCoreGray500, } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3, HeadingLevel3 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const PrivacyConsentStyled = styled.div `
  margin-top: 6px;
  a {
    color: ${colorAccentLinkLight};
  }
  ${({ isModalView }) => !isModalView &&
    css `
      background-color: ${colorCoreGray100};
      padding: 0 ${INDENT.xs};

      ${ADAPTIVE.maxWidth.mobile} {
        margin-left: -${INDENT.xs};
        margin-right: -${INDENT.xs};
        order: 1;
      }

      ${ADAPTIVE.minWidth.tablet} {
        padding: 0 ${INDENT.sm};
        order: 1;
      }

      ${ADAPTIVE.minWidth.desktop} {
        padding: ${INDENT.sm} ${INDENT.xl};
      }
      margin-bottom: ${INDENT.m};
    `}
`;
export const TitleStyled = styled(HeadingLevel3) `
  ${({ isModalView }) => isModalView
    ? css `
          ${getTextStyles('Ubuntu', 500, 18, 28)}
          text-transform: initial;
        `
    : getTextStyles('Play', 700, 24, 28)}
`;
export const SubTitleStyled = styled(RegularTextLevel3) `
  ${getTextStyles('Ubuntu', 400, 16, 18)}
  margin: 0px 0 16px;
  color: ${colorCoreBlack300};
  display: flex;
`;
export const CheckboxValueStyled = styled.span `
  ${getTextStyles('Ubuntu', 500, 16, 18)}
  display: inline-block;
`;
export const DescriptionStyled = styled.p `
  ${getTextStyles('Ubuntu', 400, 16, 24)}
  color: ${colorCoreBlack300};
  margin-top: 4px;
`;
export const PrivacyLineStyled = styled.div `
  width: 100%;
  border-top: 1px solid ${colorCoreGray500};
`;
export const AdditionalCheckboxColStyled = styled(Col) `
  ${getTextStyles('Ubuntu', 400, 16, 18)}
  color: ${colorCoreBlack900Base};
`;
export const AdditionalOptionsTitleStyled = styled.div `
  ${getTextStyles('Ubuntu', 400, 16, 24)}
  color: ${colorCoreBlack900Base};
`;
export const AdditionalOptionsStyled = styled.div `
  ${getTextStyles('Ubuntu', 400, 16, 18)}
  color: ${colorCoreBlack900Base};
`;
